import { useIntl } from 'react-intl';

import './otaBadge.scss';

/** The "⚡ OTA" label used wherever the report shows an OTA figure. */
export default function OtaBadge() {
  const { formatMessage } = useIntl();

  return (
    <span className="otaBadge">
      <span className="otaBadge__icon">
        <i className="fa-solid fa-bolt" />
      </span>
      <span className="otaBadge__label">{formatMessage({ defaultMessage: 'OTA', id: 'doohReport.ota.label' })}</span>
    </span>
  );
}
